import { computed, unref } from 'vue';

import { classesStates, propsFactory } from '@components/utils';

import type { ComputedRef, PropType } from 'vue';

export interface IReadonlyProps {
  readonly: boolean;
}
export interface IUseReadonly {
  readonlyClasses: ComputedRef<string | undefined>;
}

export const makeReadonlyProps = propsFactory(
  {
    /**
     * Только для чтения
     */
    readonly: {
      type: Boolean as PropType<boolean>,
      default: false
    }
  },
  'readonly'
);

export function useReadonly(props: IReadonlyProps): IUseReadonly {
  const readonlyClasses = computed(() => {
    const { readonly } = unref(props);
    return readonly ? classesStates.readonly : undefined;
  });

  return { readonlyClasses };
}
